
    <div *ngIf="logs" class="log-scroll">
      <!-- Today -->
      <div *ngIf="categorizedLogs.today.length > 0">
        <h6 class="log-seperator">Today</h6>
        <div *ngFor="let log of categorizedLogs.today" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- Yesterday -->
      <div *ngIf="categorizedLogs.yesterday.length > 0">
        <h6 class="log-seperator">Yesterday</h6>
        <div *ngFor="let log of categorizedLogs.yesterday" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- This Week -->
      <div *ngIf="categorizedLogs.thisWeek.length > 0">
        <h6 class="log-seperator">This week</h6>
        <div *ngFor="let log of categorizedLogs.thisWeek" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- Last Week -->
      <div *ngIf="categorizedLogs.lastWeek.length > 0">
        <h6 class="log-seperator">Last week</h6>
        <div *ngFor="let log of categorizedLogs.lastWeek" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- This Month -->
      <div *ngIf="categorizedLogs.thisMonth.length > 0">
        <h6 class="log-seperator">This month</h6>
        <div *ngFor="let log of categorizedLogs.thisMonth" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- Last Month -->
      <div *ngIf="categorizedLogs.lastMonth.length > 0">
        <h6 class="log-seperator">Last month</h6>
        <div *ngFor="let log of categorizedLogs.lastMonth" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- This Year -->
      <div *ngIf="categorizedLogs.thisYear.length > 0">
        <h6 class="log-seperator">This year</h6>
        <div *ngFor="let log of categorizedLogs.thisYear" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- Last Year -->
      <div *ngIf="categorizedLogs.lastYear.length > 0">
        <h6 class="log-seperator">Last year</h6>
        <div *ngFor="let log of categorizedLogs.lastYear" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>

      <!-- Long Ago -->
      <div *ngIf="categorizedLogs.longAgo.length > 0">
        <h6 class="log-seperator">Long ago</h6>
        <div *ngFor="let log of categorizedLogs.longAgo" class="log">
          <div class="log-header">
            <mat-icon [style.color]="typeColors.get(log.emailType) ?? 'white'" class="type-icon log-header-type">
              {{ typeIcons.get(log.emailType) ?? 'chat_bubble_outline' }}
            </mat-icon>
            {{ log.comment }}
          </div>
          <div class="log-body" fxLayout="row">
            <em>{{ getLogInfo(log) }}</em>
          </div>
        </div>
      </div>
    </div>
